import { Button, ButtonGroup, FormControl, Grid, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import Toolbar from '@mui/material/Toolbar';
import { PublicationSelector } from './PublicationSelector';
import { Heading } from './common/Heading';
import { styled } from '@mui/material/styles';
import { useDispatch } from 'react-redux';

function ToolBarPixelsSearch({ setSearchInputText, searchInputText }) {
  const dispatch = useDispatch();

  const handleChange = (event: SelectChangeEvent) => {
    dispatch({ type: 'SET_FILTER_PIXELS_SEARCH', payload: event.target.value });
  };

  const changeData =
    key =>
    ({ target: { value } }) =>
      setSearchInputText({
        ...searchInputText,
        [key]: value,
      });

  const handleSubmit = e => {
    e.preventDefault();
    dispatch({ type: 'SET_PIXELS_SEARCH_TEXT', payload: searchInputText.searchText });
  };

  return (
    <form onSubmit={handleSubmit}>
      <Toolbar style={{ paddingBottom: '45px', paddingLeft: '15px' }}>
        <Grid container alignItems={'center'} justifyContent={'space-between'} gap={'8px'}>
          <Grid item>
            <Heading>Headline Search</Heading>
          </Grid>

          <Grid item>
            <ButtonGroup>
              <FormControl
                variant="outlined"
                margin="dense"
                style={{
                  marginTop: '0px',
                  marginBottom: '0px',
                }}
              >
                <Select
                  id="formatSelection"
                  defaultValue={'vertical'}
                  onChange={handleChange}
                  sx={{
                    fontFamily: 'ProximaNovaBold',
                    textTransform: 'none',
                    color: '#000',
                    height: '43px',
                    width: '200px',
                    marginRight: '0',
                  }}
                >
                  <MenuItem value={'vertical'}>vertical</MenuItem>
                  <MenuItem value={'horizontal'}>horizontal</MenuItem>
                </Select>
              </FormControl>
            </ButtonGroup>
          </Grid>

          <Grid item flex={1}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                type={'text'}
                value={searchInputText.searchText}
                label="Search text"
                variant="outlined"
                placeholder={'eg. My article headline text'}
                onChange={changeData('searchText')}
              />
            </FormControl>
          </Grid>
          <Grid item>
            <Button color="primary" variant="contained" type={'submit'}>
              Go
            </Button>
          </Grid>
          <PublicationSelector />
        </Grid>
      </Toolbar>
    </form>
  );
}

export default styled(ToolBarPixelsSearch)`
  margin-bottom: 40px;
`;
